import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, UsersIcon } from 'lucide-react';
import { usageSteps } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/Section';
const distances = ['0K', '5K', '8K', '10K', '15K', '21K'];
export function HowItWorks() {
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-14" data-id="element-128" data-mp="3u03hhdrjhvo1">
      <Eyebrow data-id="element-129" data-mp="3u0lisot2702t">🧭 Así se usa</Eyebrow>
      <SectionTitle data-id="element-130" data-mp="lk9xuq1ww42r">
        No tenés que planificar. <span className="text-accent" data-id="element-131" data-mp="lll18org39tc">Solo seguí el camino.</span>
      </SectionTitle>

      <ol className="mt-8 grid gap-3 md:grid-cols-4" data-id="element-132" data-mp="qibgxazc83e8">
        {usageSteps.map(([number, title, text], index) => <li key={number} className="relative flex flex-col rounded-2xl border border-line bg-white p-5 shadow-sm" data-id="element-133" data-mp="crgi6rijz2od" data-mpi={index}>
            <span className="text-3xl font-black leading-none text-accent" data-id="element-134" data-mp="14je4xt9w7nrs">{number}</span>
            <p className="mt-2 text-sm font-black uppercase leading-tight text-ink md:text-base" data-id="element-135" data-mp="199ukpk16rlhb">
              {title}
            </p>
            <p className="mt-1 text-sm font-semibold leading-snug text-slate-600" data-id="element-136" data-mp="2rmpmkk6a37y2">{text}</p>
            {index < usageSteps.length - 1 && <>
                <ArrowRightIcon className="absolute -right-3 top-1/2 hidden h-5 w-5 -translate-y-1/2 text-accent md:block" aria-hidden="true" data-id="element-137" data-mp="31bha8g4b3636" />
                <ArrowDownIcon className="absolute -bottom-2.5 left-1/2 h-5 w-5 -translate-x-1/2 text-accent md:hidden" aria-hidden="true" data-id="element-138" data-mp="3ac5onbxm38gl" />
              </>}
          </li>)}
      </ol>

      <div className="mt-8 rounded-2xl border border-line bg-white p-5 shadow-sm md:p-6" data-id="element-139" data-mp="3k9tje1v7wfyr">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[.16em] text-slate-500" data-id="element-140" data-mp="3fcjymzirwsh9">
          El camino completo
        </p>
        <div className="mt-4 flex flex-wrap items-center justify-center gap-2" data-id="element-141" data-mp="1py5aohfkx9mt">
          {distances.map((distance, index) => <React.Fragment key={distance} data-id="element-142" data-mp="3l08rgkgljhlk" data-mpi={index}>
              {index > 0 && <span className="text-sm font-black text-accent" data-id="element-143" data-mp="3l1tmeb6tp2jy">→</span>}
              <span className={`rounded-lg px-3 py-1.5 text-sm font-black md:text-base ${index === 0 ? 'bg-canvas text-slate-500' : 'bg-primary text-white'}`} data-id="element-144" data-mp="3pz3j8bwjkght">
                {distance}
              </span>
            </React.Fragment>)}
        </div>
        <p className="mt-5 text-center text-sm font-semibold text-slate-600 md:text-base" data-id="element-145" data-mp="7s5pp2w3hu8k">
          Running + fuerza + técnica + descanso + progresiones, todo organizado dentro del mismo
          sistema.
        </p>
      </div>

      <p className="mt-5 flex items-start justify-center gap-2 rounded-2xl bg-primary px-5 py-4 text-left text-sm font-semibold leading-relaxed text-slate-200 md:text-base" data-id="element-146" data-mp="hkuw3jcsghx1">
        <UsersIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-147" data-mp="qkzwh9jkeg1p" />
        <span data-id="element-148" data-mp="vhqbdtjmv5lj">
          <b className="text-white" data-id="element-149" data-mp="vjb3lcih6cg8">Con alumnos:</b> evaluá → asigná nivel → aplicá planificación →
          registrá progreso.
        </span>
      </p>
    </section>;
}